import { useMemo } from "react";
import RoadmapNode from "./RoadmapNode";
import { CurriculumModule } from "./types";

// viewBox is 0..400 wide; SVG stretches with preserveAspectRatio="none".
// Side="left" rows use pr-[40%] → dot sits at ~60% horizontal = 240/400.
// Side="right" rows use pl-[40%] → dot sits at ~40% horizontal = 160/400.
const X_LEFT_SIDE = 240;
const X_RIGHT_SIDE = 160;
const ROW_HEIGHT = 100;
const TOP_OFFSET = 20;

export default function RoadmapPath({ modules }: { modules: CurriculumModule[] }) {
  const path = useMemo(() => {
    if (modules.length === 0) return "";
    let d = `M${X_LEFT_SIDE},${TOP_OFFSET}`;
    for (let i = 1; i < modules.length; i++) {
      const targetX = i % 2 === 0 ? X_LEFT_SIDE : X_RIGHT_SIDE;
      const prevX = (i - 1) % 2 === 0 ? X_LEFT_SIDE : X_RIGHT_SIDE;
      const y = TOP_OFFSET + i * ROW_HEIGHT;
      const cx = prevX;
      const cy = TOP_OFFSET + (i - 1) * ROW_HEIGHT + ROW_HEIGHT / 2;
      d += ` Q${cx},${cy} ${targetX},${y}`;
    }
    return d;
  }, [modules.length]);

  const height = TOP_OFFSET + modules.length * ROW_HEIGHT + TOP_OFFSET;

  return (
    <div className="relative">
      <svg
        className="absolute inset-0 w-full h-full pointer-events-none"
        viewBox={`0 0 400 ${height}`}
        preserveAspectRatio="none"
      >
        <path d={path} fill="none" stroke="#1f2937" strokeWidth="2" strokeDasharray="4 4" />
      </svg>
      <div className="relative">
        {modules.map((m, i) => (
          <RoadmapNode key={m.id} mod={m} side={i % 2 === 0 ? "left" : "right"} />
        ))}
      </div>
    </div>
  );
}
